import ReactJson from "react-json-view";
import { FaRegDotCircle } from "react-icons/fa";

export default function ModalComponent({ data }) {
    return (
        <div className="container-fluid font-monospace">
            <div className="row">
                <ModalDetail title="chromosome_no" text={data?.chromosome_no} />
                <ModalDetail title="position" text={data?.position} />
                <ModalDetail title="alt" text={data?.alt} />
                {/* <ModalDetail title="filter" text={data?.filter} /> */}
                <ModalDetail title="quality" text={data?.quality} />
                <ModalDetail title="ref" text={data?.ref} />

                <div className="col-12 mb-4">
                    <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                        <div className="mx-2">
                            <FaRegDotCircle className="text-primary" />
                        </div>
                        <div>information</div>
                    </div>
                    <div className="bg-light p-1 rounded" style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word" }}>
                        {data?.information}
                    </div>
                </div>
            </div>
        </div>
    );
}

function ModalDetail({ title, text }) {
    return (
        <div className="col-12 col-md-6 col-xl-4 col-xxl-3 mb-4">
            <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                <div className="mx-2">
                    <FaRegDotCircle className="text-primary" />
                </div>
                <div>{title}</div>
            </div>
            <div className="bg-light p-1 rounded" style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word", fontFamily: "monospace" }}>
                {text}
            </div>
        </div>
    );
}
